var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',{staticClass:"head"},[_vm._v("Recently Viewed")]),_c('ul',_vm._l((_vm.recentList),function(recent,index){return _c('li',{key:("recent-" + index)},[_vm._v(_vm._s(recent))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }